import jsep from 'jsep';

export const parseExpression = (expression: string) => {
  return jsep(expression);
};
